<template>
    <div class="chart-wrap">
        <div class="chart" ref="chart" v-show="!isEmpty"></div>
        <no-result v-show="isEmpty"></no-result>
    </div>
</template>

<script>
    import NoResult from '../../../components/common/NoResult'

    const option = {
        // title: {
            // text: '交易笔数',
            // subtext: '纯属虚构'
        // },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data:['交易笔数']
        },
        xAxis:  {
            type: 'category',
            boundaryGap: false,
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value} 笔'
            }
        },
        series: [
            {
                name:'交易笔数',
                type:'line',
                markPoint: {
                    data: [
                        {type: 'max', name: '最大值'},
                        {type: 'min', name: '最小值'}
                    ]
                },
                markLine: {
                    data: [
                        {type: 'average', name: '平均值'}
                    ]
                },
                smooth: true,
                color:'#66b1ff'
            }
        ]
    };


    export default {
        name: "DailyNumberChart",
        components: {
            NoResult
        },
        data() {
            return {
                isEmpty: false,
                timeArr:[],
                sumArr:[],
                AmtArr:[],
            };
        },
        props:{
            params:{
                type:Array,
                default:() => [],
            }
        },
        mounted() {
            this.init(); // 初始化图表
            // this.getData(this.params); //获取图表所需数据
        },
        watch:{
            params(newVal,oldVal){
                if (newVal) {
                    this.getData(newVal); //获取图表所需数据
                } else {
                    this.getData(oldVal); //获取图表所需数据
                }
            },
        },
        methods: {
            init() {
                this.charts = this.$echarts.init(this.$refs.chart);
                this.charts.setOption(option);
            },
            getData(params){
                if (params.length == 0) {
                    this.isEmpty = true;
                } else {
                    this.isEmpty = false;
                }
                this.charts.setOption(option);
                this.formatData(params); // 图表数据
            },
            formatData(data) {
                this.timeArr = [];
                this.sumArr = [];
                for (let i=0; i<data.length; i++) {
                    this.timeArr.push(data[i].targetTime);
                    this.sumArr.push(data[i].orderSum);
                }
                this.charts.setOption({
                    series: {
                        data: this.sumArr
                    },
                    xAxis:  {
                        data: this.timeArr
                    },
                });
            },

        }
    };

</script>

<style scoped>
    .chart-wrap{
        width: 100%;
        height: 500px;
    }
    .chart{
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/echarts/DailyNumberChart.vue